import { Delete } from 'lucide-react';

interface Props {
  value: string;
  onChange: (next: string) => void;
  maxLength?: number;
  disabled?: boolean;
}

export default function PinPad({ value, onChange, maxLength = 6, disabled }: Props) {
  const press = (key: string) => {
    if (disabled) return;
    if (key === 'clear') {
      onChange('');
      return;
    }
    if (key === 'back') {
      onChange(value.slice(0, -1));
      return;
    }
    if (value.length >= maxLength) return;
    onChange(value + key);
  };

  const keys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', 'clear', '0', 'back'] as const;

  return (
    <div className="space-y-3">
      <div className="flex justify-center gap-2 min-h-[28px]">
        {Array.from({ length: maxLength }).map((_, i) => (
          <span
            key={i}
            className={`w-3 h-3 rounded-full border ${
              i < value.length ? 'bg-primary-600 border-primary-600' : 'border-gray-300'
            }`}
          />
        ))}
      </div>
      <div className="grid grid-cols-3 gap-2 max-w-[240px] mx-auto">
        {keys.map((k) => (
          <button
            key={k}
            type="button"
            disabled={disabled}
            onClick={() => press(k)}
            className="h-12 rounded-lg border border-gray-200 bg-white text-lg font-semibold text-gray-800 hover:bg-gray-50 disabled:opacity-50 flex items-center justify-center"
          >
            {k === 'back' ? <Delete className="w-5 h-5" /> : k === 'clear' ? 'C' : k}
          </button>
        ))}
      </div>
    </div>
  );
}
